import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
export default function HomeFourBanner(){
    const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);
    return(
        <>
        <div id="slider-one" className="main-slider-area home-4">
			<div className="container">
				<div className="row align-items-center justify-content-center text-lg-start text-center">
                <ModalVideo channel='youtube' isOpen={isOpen} videoId='S05bHj0LBE4' onClose={() => { openModal(); }} />
					<div className="col-lg-6">
						<div className="rts-heading">
							<div className="title-inner">
								<h2 className="title">
									<span className="watermark"></span>
									Modern <b>Digital</b> Corporations
								</h2>
							</div>
						</div>
						<div className="section-btn">
							<div className="rts-btn">
								<a href="#">Discover More</a>
							</div>
							<div className="rts-video">
								<div className="about-video-wrapper">
									<a to="#"  onClick={() => { openModal(); }} className="popup-video">
										<i className="far fa-play"></i>
									</a>
								</div>
								<div className="video-desc">Watch Intro Video</div>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="react-image">
							<div className="react-multi-image">
								<img src="assets/img/home-4/quck-tips.webp" alt="" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        </>
    )
}